import { ActionType, ActionStatus, PolicyType, PolicyEscalationType, EscalationStatus, PolicyTargetStatus, QuoteStatus, PolicyState, StatementColumns, ActionSubStatus, ActionApprovalLogType, StatementType, } from '../models';
const action = {
    [ActionType.LATE_FEE]: {
        label: 'Invoice Late Fee',
        timelineLabel: 'late fee',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Issued',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.LATE_FEE_EMAIL]: {
        label: 'Late Fee Email',
        timelineLabel: 'late fee email',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Sent',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.DISCOUNT_APPLY]: {
        label: 'Apply Discount',
        timelineLabel: 'prompt payment discount',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Applied',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.DISCOUNT_REMOVE]: {
        label: 'Remove Discount',
        timelineLabel: 'prompt payment discount',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Removed',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.DISCOUNT_APPLIED_EMAIL]: {
        label: 'Discount Email',
        timelineLabel: 'prompt payment email',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Sent',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.REMINDER]: {
        label: 'Invoice Email',
        timelineLabel: 'invoice email',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Sent',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.SEND_SMS]: {
        label: 'Text Message (SMS)',
        timelineLabel: 'SMS message',
        webhookOnlyMessage: `This action only triggered a webhook. It was not send directly to the contact.`,
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Sent',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.DISCOUNT_REMOVED_EMAIL]: {
        label: `Discount Removed`,
        timelineLabel: `prompt payment discount`,
        status: {
            [ActionStatus.PENDING]: `Scheduled`,
            [ActionStatus.FAILED]: `Failed`,
            [ActionStatus.COMPLETE]: `Sent`,
            [ActionStatus.SUSPENDED]: `Suspended`,
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.ISSUE_STATEMENT_LATE_FEE]: {
        label: `Check Statement Interest`,
        labelShort: `Interest Check`,
        timelineLabel: `statement interest check`,
        status: {
            [ActionStatus.COMPLETE]: `Complete`,
            [ActionStatus.FAILED]: `Error`,
            [ActionStatus.PENDING]: `Scheduled`,
            [ActionStatus.SUSPENDED]: `Suspended`,
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
            [ActionSubStatus.NO_INTEREST_GENERATED]: `No Interest Issued`,
        },
    },
    [ActionType.SEND_STATEMENT_INTEREST_EMAIL]: {
        label: `Statement Interest Charge Email`,
        labelShort: `Interest Email`,
        timelineLabel: `statement interest charge email`,
        status: {
            [ActionStatus.COMPLETE]: `Sent`,
            [ActionStatus.FAILED]: `Error`,
            [ActionStatus.PENDING]: `Scheduled`,
            [ActionStatus.SUSPENDED]: `Suspended`,
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.SEND_ANNOUNCEMENT]: {
        label: `Announcement Email`,
        timelineLabel: `announcement email`,
        status: {
            [ActionStatus.COMPLETE]: `Sent`,
            [ActionStatus.FAILED]: `Error`,
            [ActionStatus.PENDING]: `Scheduled`,
            [ActionStatus.SUSPENDED]: `Suspended`,
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.SEND_STATEMENT]: {
        label: `Send Outstanding Statement`,
        labelShort: `Statement`,
        timelineLabel: `outstanding statement`,
        userDescription: `On this date, we will check if this contact has any outstanding balance. If they do, we will send them a statement.`,
        status: {
            [ActionStatus.COMPLETE]: `Complete`,
            [ActionStatus.FAILED]: `Failed`,
            [ActionStatus.PENDING]: `Scheduled`,
            [ActionStatus.SUSPENDED]: `Suspended`,
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
            [ActionSubStatus.NO_STATEMENT_SENT]: `Not Sent`,
        },
    },
    [ActionType.ESCALATION]: {
        label: 'Raise Escalation',
        timelineLabel: 'escalation',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Scheduled',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.QUOTE_EMAIL]: {
        label: 'Quote Email',
        timelineLabel: 'quote email',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Sent',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.PAYMENT_PLAN_REMINDER]: {
        label: 'Payment Plan Installment Reminder',
        timelineLabel: 'installment reminder',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Sent',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
    [ActionType.ON_DEMAND]: {
        label: 'On Demand',
        timelineLabel: 'on demand action',
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Complete',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
        subStatus: {
            [ActionSubStatus.DEFERRED]: 'Deferred',
        },
    },
};
const sendgrid = {
    event: {
        'delivered': 'Delivered',
        'processed': 'Processed',
        'dropped': 'Dropped',
        'deferred': 'Deferred',
        'bounce': 'Bounced',
        'open': 'Opened',
        'click': 'Clicked',
        'spamreport': 'Spam Report',
        'unsubscribe': 'Unsubscribed',
    },
};
const generic = {
    action: {
        status: {
            [ActionStatus.PENDING]: 'Scheduled',
            [ActionStatus.COMPLETE]: 'Complete',
            [ActionStatus.FAILED]: 'Failed',
            [ActionStatus.SUSPENDED]: 'Suspended',
            [ActionStatus.REVERTED]: 'Reverted',
            [ActionStatus.APPROVAL_PENDING]: 'Draft',
            [ActionStatus.SKIPPED]: 'Skipped',
        },
    },
    escalation: {
        status: {
            [EscalationStatus.PENDING]: 'Open',
            [EscalationStatus.COMPLETE]: 'Closed',
            [EscalationStatus.CANCELLED]: 'Cancelled',
        },
    },
};
const escalation = {
    status: {
        [EscalationStatus.PENDING]: 'Open',
        [EscalationStatus.COMPLETE]: 'Closed',
        [EscalationStatus.CANCELLED]: 'Cancelled',
    },
    type: {
        [PolicyEscalationType.CALL]: {
            label: '☎️ Escalate to call',
            timelineLabel: 'escalate to call',
            icon: '☎️',
        },
        [PolicyEscalationType.STOP_CREDIT]: {
            label: '🛑 Escalate to stop credit',
            timelineLabel: 'escalate to stop credit',
            icon: '🛑',
        },
        [PolicyEscalationType.LETTER]: {
            label: '✉️ Escalate to letter',
            timelineLabel: 'escalate to letter',
            icon: '✉️',
        },
        [PolicyEscalationType.OTHER]: {
            label: '📋 Other escalation',
            timelineLabel: 'other escalation',
            icon: '📋',
        },
    },
};
const policy = {
    labels: {
        [PolicyType.SMS]: {
            short: {
                singular: 'SMS',
                plural: 'SMS',
            },
        },
        [PolicyType.REMINDER]: {
            short: {
                singular: 'Email',
                plural: 'Emails',
            },
        },
        [PolicyType.ESCALATION]: {
            short: {
                singular: 'Escalation',
                plural: 'Escalations',
            },
        },
        [PolicyType.CONTACT_ESCALATION]: {
            short: {
                singular: 'Escalation',
                plural: 'Escalations',
            },
        },
        [PolicyType.QUOTE_EMAIL]: {
            short: {
                singular: 'Quote',
                plural: 'Quotes',
            },
        },
        [PolicyType.LATE_FEE]: {
            short: {
                singular: 'Late Fee & Interest',
                plural: 'Late Fees & Interest',
            },
        },
        [PolicyType.STATEMENT_LATE_FEE]: {
            short: {
                singular: 'Statement Interest',
                plural: 'Statement Interest',
            },
        },
        [PolicyType.STATEMENT]: {
            short: {
                singular: 'Statement',
                plural: 'Statements',
            },
        },
        [PolicyType.DISCOUNT]: {
            short: {
                singular: 'Discount',
                plural: 'Discounts',
            },
        },
        [PolicyType.PAYMENT_PLAN_REMINDER]: {
            short: {
                singular: 'Payment Plan Reminder',
                plural: 'Payment Plan Reminders',
            },
        },
        [PolicyType.ON_DEMAND_PLACEHOLDER]: {
            short: {
                singular: 'On Demand',
                plural: 'On Demand',
            },
        },
    },
    targetStatus: {
        [PolicyTargetStatus.DUE]: 'due date',
        [PolicyTargetStatus.OLDEST_DUE]: 'oldest due date',
        [PolicyTargetStatus.ISSUED]: 'issue date',
        [PolicyTargetStatus.MARKED_PAID]: 'date marked paid',
        [PolicyTargetStatus.EXPIRY_DATE]: 'expiry date',
        [PolicyTargetStatus.QUOTE_ISSUE_DATE]: 'issue date',
        [PolicyTargetStatus.INSTALMENT_DUE_DATE]: 'installment due date',
        [PolicyTargetStatus.PAYMENT_PLAN_CREATED]: 'payment plan created date',
        [PolicyTargetStatus.INVOICE_AMOUNT_UPDATED]: 'invoice amount updated',
        [PolicyTargetStatus.PROMISE_BROKEN]: 'promise broken',
        [PolicyTargetStatus.PROMISE_DUE]: 'promised payment date',
    },
    verb: {
        [PolicyType.SMS]: `sms notification`,
        [PolicyType.REMINDER]: `email`,
        [PolicyType.ESCALATION]: `escalation`,
        [PolicyType.CONTACT_ESCALATION]: `escalation`,
        [PolicyType.QUOTE_EMAIL]: `quote email`,
        [PolicyType.LATE_FEE]: `late fee`,
        [PolicyType.STATEMENT_LATE_FEE]: `statement interest charge`,
        [PolicyType.STATEMENT]: `statement`,
        [PolicyType.DISCOUNT]: `prompt payment discount`,
        [PolicyType.PAYMENT_PLAN_REMINDER]: `payment plan reminder`,
        [PolicyType.ON_DEMAND_PLACEHOLDER]: `on demand action`,
    },
    adhocVerb: {
        [PolicyType.SMS]: `sms notification`,
        [PolicyType.REMINDER]: `email`,
        [PolicyType.ESCALATION]: `escalation`,
        [PolicyType.CONTACT_ESCALATION]: `escalation`,
        [PolicyType.QUOTE_EMAIL]: `quote email`,
        [PolicyType.LATE_FEE]: `late fee`,
        [PolicyType.STATEMENT_LATE_FEE]: `statement interest charge`,
        [PolicyType.STATEMENT]: `one off statement`,
        [PolicyType.DISCOUNT]: `prompt payment discount`,
        [PolicyType.PAYMENT_PLAN_REMINDER]: `payment plan reminder`,
        [PolicyType.ON_DEMAND_PLACEHOLDER]: `on demand action`,
    },
    state: {
        [PolicyState.ACTIVE]: {
            label: `Auto`,
            tooltip: `Automatically run this policy`,
        },
        [PolicyState.INACTIVE]: {
            label: `Off`,
            tooltip: `The policy will not create any actions`,
        },
        [PolicyState.APPROVAL]: {
            label: `Draft`,
            tooltip: `Actions created by this policy will require manual approval before they are run`,
        },
    },
};
const statementColSettings = {
    [StatementColumns.Activity]: {
        label: `Activity`,
    },
    [StatementColumns.Amount]: {
        label: `Amount`,
    },
    [StatementColumns.Balance]: {
        label: `Balance`,
    },
    [StatementColumns.Date]: {
        label: `Date`,
    },
    [StatementColumns.DueDate]: {
        label: `Due Date`,
    },
    [StatementColumns.OverdueAge]: {
        label: `Overdue Age`,
    },
    [StatementColumns.Payments]: {
        label: `Payments`,
    },
    [StatementColumns.Reference]: {
        label: `Reference`,
    },
    [StatementColumns.QBOPrivateNote]: {
        label: `Statement Memo`,
    },
    [StatementColumns.PromptPaymentDiscountAmount]: {
        label: `Prompt Payment Discount`,
    },
    [StatementColumns.Tax]: {
        label: `Tax Amount`,
    },
    [StatementColumns.NetAmount]: {
        label: `Net Amount`,
    },
    [StatementColumns.PaidDate]: {
        label: `Payment Date`,
    },
};
const settings = {
    statement: {
        statementColumnSettings: statementColSettings,
    },
};
const actionApproval = {
    status: {
        [ActionApprovalLogType.APPROVAL_REVERTED]: 'Reverted',
        [ActionApprovalLogType.APPROVED]: 'Approved',
        [ActionApprovalLogType.SKIPPED]: 'Skipped',
        [ActionApprovalLogType.RUN_NOW]: 'Run now',
        [ActionApprovalLogType.CREATED_ADHOC]: 'Created',
    },
};
const quotes = {
    status: {
        [QuoteStatus.DRAFT]: 'Draft',
        [QuoteStatus.SENT]: 'Sent',
        [QuoteStatus.ACCEPTED]: 'Accepted',
        [QuoteStatus.DECLINED]: 'Declined',
        [QuoteStatus.DELETED]: 'Deleted',
        [QuoteStatus.UNKNOWN]: 'Unknown',
        [QuoteStatus.CONVERTED]: 'Converted',
    },
};
const statements = {
    [StatementType.ACTIVITY]: {
        label: `Activity`,
    },
    [StatementType.OUTSTANDING]: {
        label: `Outstanding`,
    },
};
export const langauge = {
    policyType: {
        [PolicyType.LATE_FEE]: 'Invoice Late Fee',
        [PolicyType.STATEMENT_LATE_FEE]: 'Statement Interest Charge',
        [PolicyType.STATEMENT]: 'Auto Statement',
        [PolicyType.DISCOUNT]: 'Prompt Payment Discount',
        [PolicyType.REMINDER]: 'Email',
        [PolicyType.SMS]: 'SMS Alert',
        [PolicyType.ESCALATION]: 'Escalation',
        [PolicyType.QUOTE_EMAIL]: 'Quote Email',
        [PolicyType.PAYMENT_PLAN_REMINDER]: 'Payment Plan Reminder',
        [PolicyType.ON_DEMAND_PLACEHOLDER]: 'On Demand Placeholder',
    },
    policy,
    action,
    escalation,
    sendgrid,
    generic,
    quotes,
    settings,
    actionApproval,
    statements,
};
//# sourceMappingURL=language.js.map